import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'src/common/withStyles';

import useFeatureFlag from 'src/common/hooks/useFeatureFlag';
import { getUser } from 'src/common/utils/reduxStoreSelectors';
import { decorateComponent, getClassNameFor } from '../../helpers';
import LogoutButton from './LogoutButton';
import NavItem from './NavItem';
import configItemsOld, { NavigationConfigType, charge } from './config';
import s from './Navigation.module.scss';

const SubNavigation: FC = () => {
  const user = useSelector(getUser);
  const isLoggedIn = user.get('loggedIn');
  const isCaptain = user.get('is_captain');
  const isOwner = user.get('owner_approved');
  const paymentAddOnEnabled = useFeatureFlag('payment-add-on');
  const userRoleModifier = isOwner ? 'isOwner' : 'isRenter';
  const modifiers = `subNav ${isLoggedIn ? 'authenticated' : 'anonymous'} ${userRoleModifier}`;
  let authedMenuItems = [];
  authedMenuItems = isCaptain
    ? configItemsOld.filter((config) => config.roles == null || config.roles.includes('captain'))
    : configItemsOld.filter((config) => config.roles == null || config.roles.includes('renter'));
  if (isOwner) {
    authedMenuItems = configItemsOld.filter((config) => config.roles == null || config.roles.includes('owner'));
  }

  const anonymousMenuItems = configItemsOld.filter((config) => config.roles == null || config.roles.includes('anonymous'));

  // Remove with feature flag removal
  if (paymentAddOnEnabled) {
    authedMenuItems = authedMenuItems.map((item) => (
      item.key === 'direct-booking' ? charge : item
    ));
  }

  return isLoggedIn ? (
    <>
      {(authedMenuItems as NavigationConfigType[]).map((data: NavigationConfigType) => {
        const text = data.label;
        return (
          <NavItem
            key={data.key}
            classNameModifier={`${modifiers} ${data.classNameModifier}`}
            to={typeof data.to === 'string' ? data.to : data.to[userRoleModifier]}
            external={!data.internal}
            icon={data.icon}
            openInNewTab={data.openInNewTab}
          >
            {text}
          </NavItem>
        );
      })}
      <li className={getClassNameFor(s, 'item', `${modifiers}`)}>
        <LogoutButton className={getClassNameFor(s, 'link', `${modifiers} button`)} />
      </li>
    </>
  ) : (
    <>
      {(anonymousMenuItems as NavigationConfigType[]).map((data: NavigationConfigType) => (
        <NavItem
          key={data.key}
          classNameModifier={`${modifiers} ${data.classNameModifier}`}
          to={data.to}
          icon={data.icon}
          external={!data.internal}
        >
          {data.label}
        </NavItem>
      ))}
    </>
  );
};

const decorators = [withStyles(s)];

export default decorateComponent(SubNavigation, decorators);
